<template>
	<form-field-wrap
	  :field-props="fieldProps"
	  :is-error="isError"
	  :field-value="fieldValue"
	  :is-switch="isSwitch"
	  :input-focus="inputFocus"
	>
		<template>
			<input class="form-field__input"
			       :class="inputClass"
			       type="password"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
			<div class="form-field__desc">
				<slot name="desc"></slot>
			</div>
		</template>
	</form-field-wrap>
</template>
<script>
	export default {
		name: "FormFieldPassword",
	};
</script>